import React from "react";

function Breadcrumbs({ path, onRootClick, onCrumbClick }) {
  return (
    <div
      style={{
        padding: "18px 40px 0 40px",
        fontSize: 17,
        color: "#64748b",
        display: "flex",
        alignItems: "center",
        gap: 6,
        fontWeight: 500,
      }}
    >
      <span
        style={{
          fontSize: 20,
          marginRight: 6,
          color: "#2563eb",
          cursor: "pointer",
        }}
        onClick={onRootClick}
      >
        🏠
      </span>
      {path.map((crumb, idx) => (
        <span key={crumb._id} style={{ display: "flex", alignItems: "center" }}>
          {idx > 0 && <span style={{ margin: "0 8px" }}>/</span>}
          <span
            style={{
              cursor: idx < path.length - 1 ? "pointer" : "default",
              color: idx < path.length - 1 ? "#2563eb" : "#64748b",
              fontWeight: idx === path.length - 1 ? 700 : 500,
              fontSize: 17,
            }}
            onClick={() => idx < path.length - 1 && onCrumbClick(crumb._id)}
          >
            {crumb.name}
          </span>
        </span>
      ))}
    </div>
  );
}

export default Breadcrumbs;
